function createBlobLink(blob, filename) {
    const downloadLink = document.createElement('a');
    downloadLink.target = '_blank';
    downloadLink.download = filename;

    // create an object URL from the Blob
    const URL = window.URL || window.webkitURL;
    const downloadUrl = URL.createObjectURL(blob);

    // set object URL as the anchor's href
    downloadLink.href = downloadUrl;

    // append the anchor to document body
    document.body.append(downloadLink);
    downloadLink.click();

    // cleanup: remove element and revoke object URL
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(downloadUrl);
}

function downloadPdfIE(blob, name) {
    window.navigator.msSaveOrOpenBlob(blob, filename);
}

export const downloadPdf = (data, name = 'te-template') => {
    const raw = base64ToUint8Array(data);
    const blob = new Blob([raw], { type: 'application/pdf' });
    const filename = `${name}.pdf`;

    if (navigator.msSaveBlob) {
        window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
        createBlobLink(blob, filename);
    }
}

export const base64ToUint8Array = (base64) => {
    var raw = atob(base64);
    var uint8Array = new Uint8Array(raw.length);
    for(var i = 0; i < raw.length; i++) {
        uint8Array[i] = raw.charCodeAt(i);
    }
    return uint8Array;
}